/**
 * Enum for error codes. These codes are used to identify specific errors
 * and are used for localization on FE.
 */
export enum ErrorCodes {
  // General exceptions
  INTERNAL_SERVER_ERROR = 'internalServerError',

  // Service/entity exceptions
  ENTITY_NOT_FOUND = 'entityNotFound',
  INVALID_REQUEST = 'invalidRequest',
  INVALID_DATA = 'invalidData',
  INVALID_ARGUMENT = 'invalidArgument',
  NOT_IMPLEMENTED = 'notImplemented',
  ORGANIZATION_NOT_FOUND = 'organizationNotFound',

  // Auth exceptions
  AUTH_MISSING_TOKEN = 'authMissingToken',
  AUTH_INVALID_TOKEN = 'authInvalidToken',
  AUTH_INVALID_CHAT_USER = 'authInvalidChatUser',
  AUTH_INSUFFICIENT_PERMISSIONS = 'authInsufficientPermissions',
  AUTH_USER_ALREADY_EXISTS = 'authUserAlreadyExists',
  AUTH_USER_ALREADY_VERIFIED = 'authUserAlreadyVerified',
  AUTH_VERIFICATION_EMAIL_SEND_FAILED = 'authVerificationEmailSendFailed',

  // Usage limits
  USAGE_LIMITS_EXCEEDED = 'usageLimitsExceeded',

  // Streaming exceptions
  INVALID_TOOL_CALL_CHUNK = 'invalidToolCallChunk',

  // App specific exceptions
  AGENT_DOES_NOT_EXIST = 'agentDoesNotExist',

  // tRPC exceptions
  TRPC_ERROR = 'trpcError',

  // Fastify exceptions
  FASTIFY_ERROR = 'fastifyError',

  // Stripe exceptions
  STRIPE_CUSTOMER_NOT_FOUND = 'stripeCustomerNotFound',
  STRIPE_SERVICE_UNAVAILABLE = 'stripeServiceUnavailable',
  STRIPE_API_ERROR = 'stripeApiError',
  STRIPE_SUBSCRIPTION_NOT_FOUND = 'stripeSubscriptionNotFound',
  SUBSCRIPTION_NOT_FOUND = 'subscriptionNotFound',
  SUBSCRIPTION_ALREADY_EXISTS = 'subscriptionAlreadyExists',

  // Stripe Specific Errors
  STRIPE_NOT_CONFIGURED = 'stripeNotConfigured',
  STRIPE_CUSTOMER_MISSING = 'stripeCustomerMissing',
  STRIPE_CHECKOUT_FAILED = 'stripeCheckoutFailed',
  STRIPE_PORTAL_FAILED = 'stripePortalFailed',
  STRIPE_OPERATION_FAILED = 'stripeOperationFailed',
  STRIPE_PAYMENT_AUTH_REQUIRED = 'stripePaymentAuthRequired',

  // Balance/Top-up Errors
  TOP_UP_FORBIDDEN_FREE_TIER = 'topUpForbiddenFreeTier',
}
